import Phaser from 'phaser';

import { GameAsset } from '../../services/asset-catalogue-service';
import { SolitaireMainScene } from '../../scenes/solitaire-main-scene';
import { PileView } from './pile-view';
import { DeckPileViewModel } from './deck-pile-view-model';
import { Subscription } from 'rxjs';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';

export class DeckPileView extends PileView {
  private subscriptionGroup: Subscription;
  private shakeTween?: Phaser.Tweens.Tween;
  private shakeValue = 0;

  private get deckViewModel(): DeckPileViewModel {
    return this.viewModel as DeckPileViewModel;
  }

  constructor(scene: SolitaireMainScene, x: number, y: number, viewModel: DeckPileViewModel) {
    super(scene, x, y, viewModel);

    this.subscriptionGroup = new Subscription();

    this.background.setInteractive();

    this.background.on(Phaser.Input.Events.POINTER_DOWN, () => {
      viewModel.onPointerDown();
    });

    this.subscriptionGroup.add(
      viewModel.onShakeTrigger.subscribe((_value) => {
        this.shakeDeck();
      }),
    );
  }

  override destroy(_fromScene?: boolean | undefined): void {
    this.background.off(Phaser.Input.Events.POINTER_DOWN);

    this.subscriptionGroup.unsubscribe();
  }

  public shakeDeck() {
    if (this.shakeTween !== undefined && this.shakeTween.isPlaying()) {
      return;
    }

    function wiggle(progress: number, period1: number, period2: number): number {
      const current1 = progress * Math.PI * 2 * period1;
      const current2 = progress * Math.PI * 2 * period2;

      return Math.sin(current1) * Math.cos(current2);
    }

    this.shakeTween = this.scene.tweens.add({
      targets: this,
      duration: 150,
      shakeValue: 1,
      onUpdate: (tween) => {
        this.x += wiggle(tween.progress, 7, 3) * 5;
        this.y += wiggle(tween.progress, 8, 4) * 5;
      },
      onComplete: () => {
        this.shakeValue = 0;
        this.x = 0;
        this.y = 0;
      },
    });
  }

  protected override resizeBackground(
    gameSizeMetrics: GameSizeMetrics,
    gameAsset: GameAsset,
  ): void {
    const layoutConfig = this.viewModel.layoutConfig;
    const calc = this.viewModel.calculateScaleFactor(gameSizeMetrics);

    let xPos = (gameSizeMetrics.widthDpr - calc.totalWidth * calc.scaleFactor) * 0.5;
    xPos += (gameAsset.dimensions.width + layoutConfig.hSpacing) * 6 * calc.scaleFactor;
    const yPos = layoutConfig.vPadding * calc.scaleFactor;

    this.background.setPosition(xPos, yPos);
    this.background.setDisplaySize(
      gameAsset.dimensions.width * calc.scaleFactor,
      gameAsset.dimensions.height * calc.scaleFactor,
    );
  }
}
